module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-page"
  }, [_c('div', {
    staticClass: "foo shop-page__header"
  }, [_c('div', {
    staticClass: "shop-page__header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_ci_shop')))]), _vm._v(" "), _c('p', {
    staticClass: "shop-page__subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_shop_qr')) + " / " + _vm._s(_vm.locale.t('label_warehouse')))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-page__header-actions"
  }, [_c('div', {
    staticClass: "new-button shop-page__qr-list-btn",
    on: {
      "click": function($event) {
        return _vm.openShopQrList()
      }
    }
  }, [_c('i', {
    staticClass: "ti-layout-grid2"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_shop_qr_list')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "new-button shop-page__add-btn",
    on: {
      "click": function($event) {
        return _vm.openCompanyInfoInfo('SHOP')
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_ci_shop_add')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-pos-page"
  }, [_c('div', {
    staticClass: "content-shop"
  }, [_c('div', {
    staticClass: "shop-page__stats"
  }, [_c('div', {
    staticClass: "shop-page__stat-card"
  }, [_c('span', {
    staticClass: "shop-page__stat-label"
  }, [_vm._v("Akcije")]), _vm._v(" "), _c('b', {
    staticClass: "shop-page__stat-value"
  }, [_vm._v(_vm._s(_vm.shopsActions.length))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-page__stat-card"
  }, [_c('span', {
    staticClass: "shop-page__stat-label"
  }, [_vm._v("Artikli")]), _vm._v(" "), _c('b', {
    staticClass: "shop-page__stat-value"
  }, [_vm._v(_vm._s(_vm.shops.length))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-page__stat-card"
  }, [_c('span', {
    staticClass: "shop-page__stat-label"
  }, [_vm._v("Ukupno")]), _vm._v(" "), _c('b', {
    staticClass: "shop-page__stat-value"
  }, [_vm._v(_vm._s(_vm.shopsActions.length + _vm.shops.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-page__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopSearch),
      expression: "shopSearch"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search') + '...'
    },
    domProps: {
      "value": (_vm.shopSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shopSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "products shop-products"
  }, [(_vm.filteredShopsActions.length > 0) ? _c('div', {
    staticClass: "shop-page__section-head"
  }, [_c('h3', {
    staticClass: "shop-page__section-title"
  }, [_vm._v("Akcijski Artikli")])]) : _vm._e(), _vm._v(" "), (_vm.filteredShopsActions.length > 0) ? _c('div', {
    staticClass: "grid shop-grid"
  }, _vm._l((_vm.filteredShopsActions), function(item) {
    return _c('article', {
      key: item.id,
      staticClass: "tile shop-tile",
      class: {
        'is-hidden': item.hidden
      }
    }, [_c('div', {
      staticClass: "tile-top"
    }, [_c('div', {
      staticClass: "tile-name"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)) + "\n                  "), (_vm.convertAdditionalInfo(item.additionalInfo).discount != null && _vm.convertAdditionalInfo(item.additionalInfo).discount > 0) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v("\n                    -" + _vm._s(_vm.convertAdditionalInfo(item.additionalInfo).discount) + "%\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "tile-price"
    }, [_c('s', [_vm._v(_vm._s(_vm.money(item.price, item.addInfo.currency)))]), _c('br'), _vm._v(" "), _c('b', {
      staticClass: "shop-price-strike"
    }, [_vm._v(_vm._s(item.discountPrice))]), _vm._v(" "), _c('b', {
      staticClass: "shop-price-strike"
    }, [_vm._v(_vm._s(item.addInfo.currency))])]), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('p', [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])]) : _vm._e()]), _vm._v(" "), _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": item.imageMain,
        "alt": "product image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tile-bottom"
    }, [_c('span', {
      staticClass: "badge",
      class: _vm.stockClass(item)
    }, [_vm._v(_vm._s(_vm.stockLabel(item)))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn action-btn--warehouse",
      on: {
        "click": function($event) {
          return _vm.openWarehouse(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_warehouse')))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-actions"
    }, [_c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.buyShopItem(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_buy')))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.makeAction(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_action')))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.showQrCodeForItem(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_shop_qr')))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'SHOP')
        }
      }
    }, [_vm._v("✏️")]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_vm._v("🗑")]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.hidden ? '👁‍🗨' : '🙈'))])])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid shop-grid"
  }, _vm._l((_vm.filteredShops), function(item) {
    return _c('article', {
      key: item.id,
      staticClass: "tile shop-tile",
      class: {
        'is-hidden': item.hidden
      }
    }, [_c('div', {
      staticClass: "tile-top"
    }, [_c('div', {
      staticClass: "tile-name"
    }, [_vm._v(_vm._s(_vm.getCompanyInfoName(item)))]), _vm._v(" "), _c('div', {
      staticClass: "tile-price"
    }, [_vm._v(_vm._s(_vm.money(item.price, item.addInfo.currency)))])]), _vm._v(" "), (item.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('p', [_c('i', {
      staticClass: "location-accent"
    }, [_vm._v(_vm._s(item.locations))])]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": item.imageMain,
        "alt": "product image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tile-bottom"
    }, [_c('span', {
      staticClass: "badge",
      class: _vm.stockClass(item)
    }, [_vm._v(_vm._s(_vm.stockLabel(item)))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn action-btn--warehouse",
      on: {
        "click": function($event) {
          return _vm.openWarehouse(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_warehouse')))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-actions"
    }, [_c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.buyShopItem(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_buy')))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.makeAction(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_action')))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.showQrCodeForItem(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_shop_qr')))]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.editCompanyInfo(item.id, 'SHOP')
        }
      }
    }, [_vm._v("✏️")]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.deleteCompanyInfo(item.id, item.name)
        }
      }
    }, [_vm._v("🗑")]), _vm._v(" "), _c('button', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          return _vm.hideCompanyInfo(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.hidden ? '👁‍🗨' : '🙈'))])])])
  }), 0)])])]), _vm._v(" "), _c('show-qr-code-dialog', {
    attrs: {
      "show": _vm.showQrCodeItem != null,
      "item": _vm.showQrCodeItem
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-page__section-head"
  }, [_c('h3', {
    staticClass: "shop-page__section-title"
  }, [_vm._v("Svi Artikli")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2155039a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop/ShopPage.vue
// module id = 717
// module chunks = 0